import React from 'react';
import PropTypes from 'prop-types';
import {
	LockerComparisonTable,
	LockerComparisonHeader,
} from 'components/molecules';
import './LockerComparison.scss';

export function LockerComparison({ content }) {
	const {
		title,
		description,
		footerText,
		lockerColumnLabel,
		regularColumnLabel,
		rows,
	} = content;

	return (
		<section className="locker-comparison">
			<LockerComparisonHeader
				title={title}
				description={description}
			/>
			<LockerComparisonTable
				rows={rows}
				lockerColumnLabel={lockerColumnLabel}
				regularColumnLabel={regularColumnLabel}
			/>
			{footerText && (
				<p className="locker-comparison__footer">{footerText}</p>
			)}
		</section>
	);
}

LockerComparison.propTypes = {
	content: PropTypes.shape({
		title: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired,
		footerText: PropTypes.string,
		lockerColumnLabel: PropTypes.string.isRequired,
		regularColumnLabel: PropTypes.string.isRequired,
		rows: PropTypes.arrayOf(
			PropTypes.shape({
				feature: PropTypes.string.isRequired,
				locker: PropTypes.string.isRequired,
				regular: PropTypes.string.isRequired,
			}),
		).isRequired,
	}).isRequired,
};

export default LockerComparison;
